export const PERIOD_OPTIONS = {
  reportYear: [
    "DealerName",
    "INN",
    "filial",
    "FO",
    "subject",
    "city",
    "entfCode",
    "entfSuccessorCode",
    "entfSuccessorNo",
    "leaderRegionalSalesManager",
    "regionalSalesManager",
    "leaderRegionalServiceManager",
    "regionalServiceManager",
  ],
  reportDealer: [
    "quarter",
    "year",
    "leaderRegionalSalesManager",
    "regionalSalesManager",
    "leaderRegionalServiceManager",
    "regionalServiceManager",
  ],
  reportRegMen: [
    "quarter",
    "year",
    "DealerName",
    "INN",
    "filial",
    "FO",
    "subject",
    "city",
    "entfCode",
    "entfSuccessorCode",
    "entfSuccessorNo",
  ],
  reportAll: ["regionalManager", "role"],
};

// Права на просмотр (view) и выгрузку файла (file) по типам отчётов
export const REPORT_PERMISSIONS = {
  reportYear: {
    view: "users.getReportRegMenByDealerByPeriod",
    file: "users.getReportFileRegMenByDealerByPeriod",
  },
  reportDealer: {
    view: "users.getReportRegMenByDealerByDealer",
    file: "users.getReportFileRegMenByDealerByDealer",
  },
  reportRegMen: {
    view: "users.getReportRegMenByDealerByRegMen",
    file: "users.getReportFileRegMenByDealerByRegMen",
  },
  reportAll: {
    view: "users.getReportRegMenByDealerConsolidate",
    file: "users.getReportFileRegMenByDealerConsolidate",
  },
};
